<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [fullScreen]="true"
  (onHiding)="onClosingByCrossIcon($event)"
  [(visible)]="displayDialog"
>
  @if (_bonCf) {
  <div class="d-flex flex-column">
    <div class="d-flex flex-row">
      <div class="d-flex flex-column mg-r-20 panel-fournisseur col-3">

        <label title="Fournisseur">
          <i class="fas fa-truck mg-r-5"></i>{{ _bonCf?.fournisseurLibelle | titlecase }}
        </label>

        <label title="Unité de production">
          <i class="fas fa-map-marker mg-r-5"></i>
          {{ _bonCf?.uniteDeProductionLibelle | titlecase }}
        </label>

        <label title="Code Client">
          Code Client : {{ udpSecteurFournisseur?.codeClient| titlecase }}
        </label>

        <label class="d-flex align-items-center" title="Date de livraison prévue">
          <i class="fas fa-calendar mg-r-5"></i>Livraison prévue le
          <dx-date-box
            class="ml-4"
            title="Date de livraison ajustée"
            type="date"
            [(ngModel)]="dateLivCalendar"
            (ngModelChange)="onDateLivUpdated()"
            [ngModelOptions]="{standalone: true}"
            displayFormat="dd/MM/yyyy"
            [calendarOptions]="{
              firstDayOfWeek: 1,
              cellTemplate: 'dayCellTemplate'
            }"
            [disabledDates]="disabledDates">
            <div *dxTemplate="let data of 'dayCellTemplate'">
              @if (utils.isDateOk(data.date, joursSemaineFournisseur) && !this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(data.date, this.fermeturePonctuelleList)) {
                <div class="creation-menus-day" title="Jour de livraison.">
                  {{ data.text }}
                </div>
              }
              @if (utils.isDateOk(data.date, joursSemaineFournisseur) && this.fermeturePonctuelleSvc.isDateOnFermeturePonctuelle(data.date, this.fermeturePonctuelleList)) {
                <div class="disabled-day-fermeture-ponctuelle" title="Fermeture ponctuelle de la cuisine">
                  {{ data.text }}
                </div>
              }
              @if (!utils.isDateOk(data.date, joursSemaineFournisseur)) {
                <div class="disabled-day" title="Jour de livraison NON paramétré pour ce fournisseur">
                  {{ data.text }}
                </div>
              }
            </div>
          </dx-date-box>
        </label>
      </div>
      <div class="d-flex flex-column col-9">
        <div>
          <label>Remarques &nbsp;</label>
          <label id="remarque"
                 [class.remarque-error]="isRemarqueInError()">
            ({{ getNbCaracteresCommentaire() }}/5000 caractère(s)) &nbsp;: &nbsp;
          </label>

          <dx-html-editor
            [value]="_bonCf.commentaire"
            (onValueChanged)="onCommentaireChanged($event)"
            height="200"
            [toolbar]="toolbarOptions"
            [placeholder]="'Saisir vos remarques ici...'">
          </dx-html-editor>

        </div>
      </div>
    </div>
    <div class="border-header">
      <div style="text-align: left;">
        @if (auth2Svc.isSiteLocal(_bonCf.site.id)) {
                    <span>
                      <yo-button label="Ajouter des articles"
                                 [theme]="ButtonThemeEnum.ADD"
                                 iconClass="fas fa-plus"
                                 (onClick)="showDialogAddArticles()">
                      </yo-button>
                      🗣️<em> N'oubliez pas d'enregistrer votre travail.</em>
                    </span>
          <span class="space cursor mg-r-5 floatright">
                    <yo-button
                      iconClass="fas fa-trash"
                      [theme]="ButtonThemeEnum.DELETE_INNER"
                      (onClick)="removeLignesCommande()"
                      [disabled]="utils.isCollectionNullOrEmpty(selectedRows)"
                      tooltip="Supprimer les articles sélectionnés de la proposition de commande... Il ne seront réellement supprimés que lorsque vous enregistrerez.">
                  </yo-button>
                    </span>
        }
      </div>
    </div>
    <div>
      <dx-data-grid
        [dataSource]="_lignesBonCf"
        [height]="utils.getWindowAvailableHeight(550)"
        keyExpr="idCatalogueAchat"
        width="100%"
        [allowColumnResizing]="true"
        [hoverStateEnabled]="true"
        [rowAlternationEnabled]="true"
        [showRowLines]="true"
        [showBorders]="true"
        (onEditorPreparing)="onEditorPreparing($event)"
        [(selectedRowKeys)]="selectedRows"
        #grid>
        <dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="false" [allowDeleting]="false"></dxo-editing>
        <dxo-selection [selectAllMode]="allMode" [showCheckBoxesMode]="checkBoxesMode" mode="multiple"></dxo-selection>

        <dxi-column dataField="codeProduitDecline" caption="Code denrée"
                    [allowEditing]="false" [width]="100"></dxi-column>
        <dxi-column dataField="referenceArticle" cellTemplate="templateReferenceArticle" caption="Réf. article"
                    [allowEditing]="false" [width]="100"></dxi-column>
        <dxi-column dataField="description" cellTemplate="templateDescription" caption="Description"
                    [allowEditing]="false" [width]="300"></dxi-column>
        <dxi-column dataField="prixUnitaire" cellTemplate="templatePrixUnitaire" caption="PU UF"
                    [setCellValue]="changePrixUnitaire"></dxi-column>
        <dxi-column dataField="quantiteAFacturer" caption="Qté Fact. UF" cellTemplate="templateQteAFacturer"
                    [allowEditing]="false"></dxi-column>
        <dxi-column dataField="quantiteACommander" caption="Qté Com. UC" cellTemplate="templateQteACommander"
                    [allowEditing]="false"></dxi-column>
        <dxi-column dataField="quantiteACommanderAjustee" caption="Qté Com. Aju. UC" cellTemplate="templateQteAjustee"
                    [setCellValue]="changeQteAjustee"></dxi-column>
        <dxi-column dataField="prixTotal" caption="Prix Total" cellTemplate="templatePrixTotal"
                    [allowEditing]="false"></dxi-column>
        <dxi-column dataField="quantiteBesoin" caption="Besoin UT" cellTemplate="templateBesoinUT"
                    [allowEditing]="false"></dxi-column>
        <dxi-column dataField="quantiteStock" caption="Qté Stock" cellTemplate="templateStock"
                    [allowEditing]="false"></dxi-column>
        <dxi-column dataField="commentaire" caption="Remarque" cellTemplate="templateRemarque"
                    [setCellValue]="changeRemarque"></dxi-column>

        <div *dxTemplate="let cell of 'templateTva'" class="text-left">
          {{ tva }}
        </div>
        <div *dxTemplate="let cell of 'templateReferenceArticle'" class="text-left">
          <span class="space">{{ cell.row.data.referenceArticle }}</span>
          @if (cell.row.data.id===0) {
            <span><label class="badge badge-success">Ajouté manuellement</label></span>
          }
        </div>
        <div *dxTemplate="let cell of 'templateDescription'" class="text-left" style="white-space: pre-wrap;">
          {{ cell.row.data.description }}
          <br/>
          <yo-info-lotmarche-article [uniteDeProductionId]="_bonCf?.uniteDeProductionId"
                                     [lotMarchePdLumpCa]="cell.row.data.lmPdUpCa"
                                     [checkUniteDeProduction]="false"></yo-info-lotmarche-article>
        </div>
        <div *dxTemplate="let cell of 'templatePrixUnitaire'" class="save-color cursor text-left">
          <span class="space">
            {{ cell.row.data.prixUnitaire | currency:'EUR':'symbol':'1.3-3' }}
            / {{ cell.row.data.uniteDeFacturation.abreviation | titlecase }}
          </span>
          @if (cell.row.data.prixUnitaire < 0) {
            <span>
              <i class="fas fa-exclamation-triangle danger-color space" title="Le prix doit être supérieur à 0"></i>
            </span>
          }
        </div>
        <div *dxTemplate="let cell of 'templateQteAFacturer'" class="text-left"
             title="Quantité à facturer, 1 {{cell.row.data.uniteDeFacturation.libelle}} = {{cell.row.data.ratioUF}} KG">
          {{ cell.row.data.quantiteAFacturer | number:'1.3-3' }} {{ cell.row.data.uniteDeFacturation.abreviation | titlecase }}
        </div>
        <div *dxTemplate="let cell of 'templateQteACommander'" class="text-left"
             title="Quantité à commander, 1 {{cell.row.data.uniteDeCommande.libelle}} = {{cell.row.data.ratioUC}} KG">
          {{ cell.row.data.quantiteACommander | number:'1.3-3' }} {{ cell.row.data.uniteDeCommande.abreviation | titlecase }}
        </div>
        <div *dxTemplate="let cell of 'templateQteAjustee'" class="save-color cursor text-left">
          <span
            class="space">{{ cell.row.data.quantiteACommanderAjustee | number:'1.3-3' }}  {{ cell.row.data.uniteDeCommande.abreviation | titlecase }}</span>
          @if (cell.row.data.horsDelai || (cell.row.data.delaiCommande && isOutOfDate(cell.row.data?.delaiCommande))) {
            <i class="fas fa-business-time danger-color" title="Article avec délai de commande spécifique dépassé ({{cell.row.data.delaiCommande}}j)"></i>
          }
          @if (isBelowMinimumCommande(cell.row.data)) {
            <span>
              <i class="fas fa-cart-arrow-down danger-color space"
                 title="Minimum de commande {{cell.row.data.minimumDeCommande}} {{cell.row.data.uniteDeCommande.libelle}}"></i>
            </span>
          }
          @if (isConditionneParInError(cell.row.data)) {
            <span>
              <i class="fas fa-box-open danger-color space"
                 title="Conditionné par {{cell.row.data.conditionnePar}} {{cell.row.data.uniteDeCommande.libelle}}"></i>
            </span>
          }
        </div>
        <div *dxTemplate="let cell of 'templateBesoinUT'" class="text-left"
             title="1 {{cell.row.data.uniteTechnique.libelle}} = {{cell.row.data.ratioUT}} KG">
          {{ cell.row.data.quantiteBesoin | number:'1.3-3' }} {{ cell.row.data.uniteTechnique.libelle | titlecase }}
        </div>
        <div *dxTemplate="let cell of 'templatePrixTotal'" class="text-left">
          {{ cell.row.data.prixTotal | currency:'EUR':'symbol':'1.3-3' }}
        </div>
        <div *dxTemplate="let cell of 'templateStock'" class="text-left">
          <span>{{ cell.row.data.quantiteStock }} {{ cell.row.data.uniteDeCommande.libelle | titlecase }}</span>
        </div>
        <div *dxTemplate="let cell of 'templateRemarque'" class="save-color cursor text-left">
          {{ cell.row.data.commentaire }}
        </div>

        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-paging [pageSize]="100"></dxo-paging>
        <dxo-pager
          [showPageSizeSelector]="true"
          [showNavigationButtons]="false"
          [allowedPageSizes]="[20, 50, 100, 200]"
          [visible]="true"
          [showInfo]="true"
          infoText="{2} article(s)">
        </dxo-pager>
      </dx-data-grid>
    </div>
    <div class="border-footer">
      @if (_bonCf.fournisseurFdpActif) {
        <div class="row">
          <div class="col-md-11 text-right">
            @if (getFrancoDePort(_bonCf,_lignesBonCf) > 0) {
              <i class="fas fa-truck danger-color cursor pulse"
                 [title]="getTooltipFraisDePort(_bonCf)"></i>
            }
            Frais de port
          </div>
          <div class="col-md-1 text-right border">
            {{ getFrancoDePort(_bonCf, _lignesBonCf) | currency:'EUR':'symbol':'1.2-2' }}
          </div>
        </div>
      }
      <div class="row">
        <div class="col-md-11 text-right">Montant HT</div>
        <div class="col-md-1 text-right border">{{ _bonCf.montantHT | currency:'EUR':'symbol':'1.2-2' }}</div>
      </div>
      <div class="row">
        <div class="col-md-11 text-right">TVA</div>
        <div class="col-md-1 text-right border">{{ tva | currency:'EUR':'symbol':'1.2-2' }}</div>
      </div>
      <div class="row">
        <div class="col-md-11 text-right">Montant TTC</div>
        <div
          class="col-md-1 text-right border">{{ _bonCf.montantHT + tva  | currency:'EUR':'symbol':'1.2-2' }}
        </div>
      </div>
    </div>

    <div class="d-flex mg-t-5">
      <div class="mr-auto"></div>
      <div>

          @if (auth2Svc.isSiteLocal(_bonCf.site.id)) {
            <span class="mg-r-5">
              <yo-button iconClass="fa fa-home"
                         [theme]="ButtonThemeEnum.DEFAULT"
                         (onClick)="updateDeliveryDate()"
                         label="Modifier l'adresse de livraison">
              </yo-button>
            </span>
          }

        <span class="mg-r-5">
            <yo-button iconClass="fas fa-print"
                       [theme]="ButtonThemeEnum.DEFAULT"
                       (onClick)="imprimerBonDeCommande()"
                       label="Imprimer">
            </yo-button>
          </span>

        @if (auth2Svc.isSiteLocal(_bonCf.site.id)) {
          <span class="mg-r-5">
              <yo-button iconClass="fas fa-save"
                         [theme]="ButtonThemeEnum.SAVE"
                         [disabled]="!isSaveAllowed()"
                         (onClick)="sauverBonCommande()"
                         label="Enregistrer"></yo-button>
            </span>
        }

        <yo-button iconClass="fas fa-times"
                   [theme]="ButtonThemeEnum.CANCEL_INNER"
                   (onClick)="closeDialog()"
                   label="Fermer">
        </yo-button>
      </div>
    </div>

    @if (onModif) {
      <p>
        🗣️<em> N'oubliez pas d'enregistrer.</em>
      </p>
    }

  </div>
  }
</dx-popup>

<!--AJOUTER UN ARTICLE FOURNISSEUR À LA PROPOSITION DE COMMANDE-->
<yo-bc-add-article-fournisseur
  (onSave)="addArticles($event)">
</yo-bc-add-article-fournisseur>

<yo-bc-edit-delivery-address
  [bonCf]="_bonCf"
  [displayDialog]="displayDialogEditDeliveryDate"
  (onClose)="closeDialogEditDeliveryDate($event)"
></yo-bc-edit-delivery-address>


<!--TEMPLATE DU CALENDRIER POUR LE HIGHLIGHT DES DATES QUI CORRESPONDENT AUX JOURS DE LIVRAISON DU SECTEUR FOURNISSEUR SÉLECTIONNÉ-->
<ng-template #tplDateMenuCompo let-isDateFournisseur="isDateFournisseur" let-date="date">
  @if (isDateFournisseur) {
    <div class="selected-day" title="Jour de livraison paramétré pour ce fournisseur">
      {{ date.day }}
    </div>
  }
  @if (!isDateFournisseur) {
    <div title="Jour de livraison NON paramétré pour ce fournisseur">{{ date.day }}</div>
  }
</ng-template>

<!--TEMPLATE FRAIS DE PORT-->
<ng-template #tplFraisDePort let-fraisDePort="fraisDePort">

  @if (_bonCf.fournisseurFdpActif) {
    <div class="row">
      <div class="col-md-8 text-left">
      </div>
      <div class="col ">
        <div class="row">
          <div class="col-md-8 text-right">
            @if (fraisDePort > 0) {
              <i class="mg-r-5 fas fa-exclamation-triangle danger-color cursor pulse"
                 [title]="getTooltipFraisDePort(_bonCf)"></i>
            }
            Frais de port
          </div>
          <div class="col text-right border">{{ fraisDePort | currency:'EUR':'symbol':'1.2-2' }}</div>
        </div>
      </div>
    </div>
  }

</ng-template>

